import React, { VFC } from 'react';
import T from 'i18n-react';
import { makeStyles } from '@material-ui/core/styles';
import TimelineItem from '@material-ui/lab/TimelineItem';
import PassengerImage from '../../../../images/plans/passenger.png';
import AccordionTimelineSeparator from './AccordionTimelineSeparator';
import AccordionTimeLineContent from './AccordionTimeLineContent';
import Meeting from './Meeting';

const useStyles = makeStyles((theme) => ({
  missingOppositeContent: {
    '&:before': {
      display: 'none',
    },
  },
  timelineIcon: {
    width: 40,
    height: 'auto',
    [theme.breakpoints.up('sm')]: {
      width: 50,
    },
  },
}));

interface Props {
  isMeetingHidden: boolean;
}
const MeetingTimelineItem: VFC<Props> = ({ isMeetingHidden }: Props) => {
  const classes = useStyles();
  return (
    <TimelineItem
      classes={{
        missingOppositeContent: classes.missingOppositeContent,
      }}
    >
      <AccordionTimelineSeparator hasConnector>
        <img
          src={PassengerImage}
          className={classes.timelineIcon}
          alt={T.translate('planPage.planTerms.firstDay') as string}
        />
      </AccordionTimelineSeparator>
      <AccordionTimeLineContent
        title={T.translate('planPage.planTerms.firstDay') as string}
      >
        {!isMeetingHidden && <Meeting />}
      </AccordionTimeLineContent>
    </TimelineItem>
  );
};

export default MeetingTimelineItem;
